"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableBookingInsuranceExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const deserializer_1 = tslib_1.__importDefault(require("../../../../utils/deserializer"));
const Booking_1 = tslib_1.__importDefault(require("../../bookings/__models__/Booking"));
const enableBookingInsurance = toolkitRaw.createAsyncThunk('bookings/enable_insurance', async ({ id }, { rejectWithValue, getState }) => {
    var _a;
    const state = getState();
    const isUserInsuranceEnabled = (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.meta.insured;
    if (!isUserInsuranceEnabled) {
        return rejectWithValue('Insurance not active');
    }
    try {
        const response = await services_1.default.post(`/api/saas/me/bookings/${id}/insurances/enable`);
        const payload = (0, deserializer_1.default)(response.data);
        const BookingImplementation = new Booking_1.default(payload);
        return BookingImplementation.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const enableBookingInsuranceExtraReducers = (builder) => {
    builder.addCase(enableBookingInsurance.pending, (state) => {
        state.booking.loading = true;
    });
    builder.addCase(enableBookingInsurance.fulfilled, (state, action) => {
        state.booking.loading = false;
        state.booking.data = action.payload;
    });
    builder.addCase(enableBookingInsurance.rejected, (state) => {
        state.booking.loading = false;
    });
};
exports.enableBookingInsuranceExtraReducers = enableBookingInsuranceExtraReducers;
exports.default = enableBookingInsurance;
//# sourceMappingURL=index.js.map